import { FieldSectionAPIClient } from 'module/api/field-section';
import { axiosInstance } from 'api/axios';

export const FieldSectionAPI = new FieldSectionAPIClient(axiosInstance);
